import React from 'react';
import { Tooltip } from '@mui/material';

const defaultTooltipSx = {
  maxWidth: '288px',
  padding: '16px',
  borderRadius: '8px',
  background: 'rgba(97, 97, 97, 0.92)',
  color: '#FFF',
  fontFamily: 'Noto Sans',
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: 'normal',
  boxShadow: '4px 4px 8px 0 rgba(0, 0, 0, 0.20)',
};

const defaultPopperModifiers = [
  {
    name: 'offset',
    options: {
      offset: [0, -8],
    },
  },
];

const StyledTooltip = ({ children, tooltipSx, arrowSx, popperModifiers, showArrow = true, ...props }) => (
  <Tooltip
    arrow={showArrow}
    {...props}
    slotProps={{
      tooltip: {
        sx: { ...defaultTooltipSx, ...tooltipSx },
      },
      arrow: {
        sx: arrowSx,
      },
      popper: {
        modifiers: popperModifiers || defaultPopperModifiers,
      },
    }}
  >
    {children}
  </Tooltip>
);

export default StyledTooltip;
